import { render, staticRenderFns } from "./IconBra.vue?vue&type=template&id=c540a204"
import script from "./IconBra.vue?vue&type=script&lang=js"
export * from "./IconBra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports